import React, {useState, useRef, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import {InputText} from 'primereact/inputtext';
import {Password} from 'primereact/password';
import {Button} from 'primereact/button';
import {Card} from 'primereact/card';
import {Message} from 'primereact/message';
import axios from "axios";
import '../assets/css/login.css'

const LoginPage = () => {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [userId, setUserId] = useState(null);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("token");
      const expiryTime = localStorage.getItem("expiryTime");
      const currentTime =  new Date().getTime();

      if(userId && token && expiryTime && currentTime < Number(expiryTime)){
        navigate("/Pages/Home")
      }
    }, [navigate])

    const handleLogin = async (e) => {

    e.preventDefault();

    const p_param = {
    "p_user_name": username,
    "p_password": password,
    "p_app_code": "BOOK"
        }
      try {
        const response = await axios.post("https://books.radixtax.com/api/login/getValidatePassword",p_param);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            console.log("success=Y");
            setUserId(response.data[1]);
            localStorage.setItem("userId", response.data[1]);
            localStorage.setItem("token", response.data[2]);
            localStorage.setItem("expiryTime", response.data[4]);
            navigate("/Pages/Home")
          } else {
            //setRows(null);
            setUserId(null);
            const errorInfo = response.data[3];
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setUserId(null);
        }

        //setRows(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
         alert(error.message);
      }
    };

// const header = (
//     <div className="login-title">Login</div>
// )

return(
    <div className="login-wrapper">
        <Card title="Login" className="login-card">
            <form onSubmit={handleLogin} autoComplete="on" method="POST">
            <div className="field">
                <label htmlFor="username">Username</label>
                <InputText id="username" name="username" type="text" value={username} autoComplete="username" onChange={(e) => setUsername(e.target.value)}
                className="w-full"/>
            </div>
            <div className="field">
                <label htmlFor="password">Password</label>
                <Password id="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)}
                toggleMask feedback={false} autoComplete="current-password" className="w-full" inputStyle={{width: "19.5rem"}}/>
            </div>
            {error && <Message severity="error" text={error} className="mb-3"/>}
            <Button label="Login" icon="pi pi-sign-in" type="submit" className="w-full tight-icon" />
            </form>
        </Card>
    </div>
)
}

export default LoginPage;